import { Outlet } from "react-router";
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/Footer";
import Preloader from "@/components/Preloader/Preloader";
import { CustomCursor } from "@/components/animations";
import SEO from "@/components/seo/SEO";
import { WEBSITE_SCHEMA } from "@/lib/seo/siteSchema";

export default function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col w-full overflow-x-hidden">
      <SEO schema={WEBSITE_SCHEMA} />
      <CustomCursor />
      <Preloader />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
